import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  width: 100%;
  height: 100%;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  table-layout: fixed;
`;
export const ThTable = styled(Table)`
  height: 27px;
`;
export const Thead = styled.thead`
  background-color: ${ColorSF2.white};
`;
export const TheadTr = styled.tr`
  border-top: 1px solid ${ColorSF2.mediumGray};
  text-decoration: none;
  cursor: pointer;
  height: 27px;
  font-size: 12px;
  display: flex;
  align-items: center;
`;
export const Tbody = styled.tbody`
  width: 100%;
  background-color: ${ColorSF2.white};
`;

export const TbodyTr = styled.tr`
  width: 100%;
  height: 32px;
  border-top: 1px solid ${ColorSF2.mediumGray};
  text-decoration: none;
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};
  display: flex;
  flex-direction: row;
  background-color: ${props =>
    props.checked ? ColorSF2.skyBlue : ColorSF2.white};

  &: hover {
    background-color: ${ColorSF2.skyBlue};
  }

  &: last-child {
    border-bottom: 1px solid ${ColorSF2.mediumGray};
  }
`;
export const ThCheckbox = styled.th`
  width: 35px;
  @media (max-width: 830px), (max-height: 530px) {
    width: 24px;
  }
`;
export const TdCheckbox = styled.td`
  width: 35px;
  @media (max-width: 830px), (max-height: 530px) {
    width: 24px;
  }
`;
export const ThOperatorName = styled.th`
  overflow: hidden;
  padding-left: 10px;
  tex-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
`;
export const TdOperatorName = styled.td`
  width: calc(100% - 40px);
  padding: 0px;
  padding-left: 6px;
  display: flex;
  flex: 1;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
`;

export const ScrolledBody = styled.div`
  width: 100%;
  height: calc(100% - 27px);
  overflow-x: hidden;
  overflow-y: auto;
`;

export const SortWrapper = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;

export const OperatorNameWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const OperatorName = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const ChevronImage = styled.img`
  height: 18px;
`;
